import React from 'react';
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
} from 'react-google-maps';

import PIN from 'assets/img/pin.svg';
import PIN_GREEN from 'assets/img/pin_grin.svg';

const MapWithMarker = withScriptjs(withGoogleMap(props => (
  <GoogleMap
    defaultZoom={8}
    center={props.center}
    defaultOptions={{
      streetViewControl: false,
      scaleControl: false,
      mapTypeControl: false,
      panControl: false,
      zoomControl: false,
      rotateControl: false,
      fullscreenControl: false,
    }}
  >
    <Marker
      icon={{ url: props.isOverriden ? PIN_GREEN : PIN, scaledSize: { width: 40, height: 60 } }}
      position={props.markerPosition}
    />
  </GoogleMap>
)));

const Map = props => (
  <MapWithMarker
    containerElement={<div style={{ height: '300px', width: '300px', ...props.style }} />}
    googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyB5UzMrTIiD2z6t2Qd89op9h6xR0Cx0Z1s&v=3.exp&libraries=places"
    loadingElement={<div style={{ height: '100%' }} />}
    mapElement={<div style={{ height: '100%', ...props.mapStyle }} />}
    center={props.markerPosition}
    markerPosition={props.markerPosition}
    isOverriden={props.isOverriden}
  />
);
export { Map };



// WEBPACK FOOTER //
// ./src/view/common/Map/index.jsx